import React, { Component } from "react";
import Footer from "../../Layout/Footer2";
import Header from "../../Layout/Header";
import { Helmet } from 'react-helmet';
import api from '../Api';
import { Link } from "react-router-dom";
import ContentJobs from '../../Element/ContentJobs';
import Jobfindbox from "../../Element/Jobfindbox2";

const axios = require('axios');

class JobsInSpain extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobs: [],
            total: '',
            isLoading: true
        };
    }

    componentDidMount() {
        this.getJobs();
    }

    getJobs() {
        axios
            .request(api.getJobs('', 'Spain'))
            .then((response) => {
                this.setState({
                    jobs: response.data.jobs,
                    total: response.data.pagesInfo.totalJobs,
                    pages: response.data.pagesInfo.totalpages,
                    page: response.data.pagesInfo.page,
                    perPage: response.data.pagesInfo.perPage,
                    prevPage: response.data.pagesInfo.prevPage,
                    nextPage: response.data.pagesInfo.nextPage,
                    isLoading: false
                });
            })
            .catch((error) => {
                console.error(error);
                this.setState({ isLoading: false });
            });
    }

    render() {
        let { jobs, total, page, pages, prevPage, nextPage, isLoading } = this.state;

        return (
            <div className="page-wraper">
                <Header />

                <Helmet>
                    <title>Jobs in Spain: Find your job here on #OpenToWorkRemote!</title>
                    <meta name="description" content="Looking for jobs in Spain? Find your dream job here and apply today!" />
                    <link rel="canonical" href="https://www.opentoworkremote.com/jobs-in-spain" />
                </Helmet>

                <div className="page-content bg-white">
                    <div className="dez-bnr-inr bg-dark">
                        <div className="container">
                            <div className="dez-bnr-inr-entry">
                                <Link to={""}>
                                    <h1 className="text-white">
                                        Find jobs in Spain
                                    </h1>
                                </Link>
                                <div className="breadcrumb-row">
                                    <ul className="">
                                        <li>Connect with Spanish companies offering remote work opportunities</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Jobfindbox myLocation="Spain" />

                    <ContentJobs
                        jobs={jobs}
                        total={total}
                        page={page}
                        pages={pages}
                        prevPage={prevPage}
                        nextPage={nextPage}
                        isLoading={isLoading}
                    />
                </div>

                <Footer />
            </div>
        );
    }
}

export default JobsInSpain;
